import { type Category } from '@v2/shared/lib/types';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import { FullScreenDialog, MenuPanel } from '@v2/brands/discountmags/Layouts/Full/Navigation';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  close: () => void;
  closeMenu: () => void;
  categories: Category[];
};

export default function CategoriesDialog({
  isOpen,
  toggle,
  title = 'All Categories',
  close,
  closeMenu,
  categories,
}: Props) {
  const { buildUrl } = useUrlGenerator();

  return (
    <FullScreenDialog
      slideInFrom="right"
      isOpen={isOpen}
      toggle={toggle}
      close={() => {
        close();
        closeMenu();
      }}
      title="Categories"
      showBackButton
      onBack={close}
    >
      <div className="text-lg font-semibold px-4 py-3 border-b-[1.5px] border-slate-100">{title}</div>
      {categories.map((category) => (
        <MenuPanel.Item
          key={category.id}
          href={buildUrl(category.href)}
          iconName={category.icon}
          title={category.name}
        />
      ))}
    </FullScreenDialog>
  );
}
